import { Box } from "@mui/material";
import React from "react";
import { AddCircleOutline, Download } from "@mui/icons-material";
import DashboardTopTitle from "../../../components/DashboardTopTitle";
import ReferralTable from "./ReferralTable";

const Referrals = () => {
  return (
    <Box>
      <DashboardTopTitle
        title="Referrals"
        subtitle="Showing data over the last 30 days."
        onClickFirst={() => {}}
        firstBtnIcon={<Download />}
        firstBtnTitle="Export CSV"
        secondBtnIcon={<AddCircleOutline />}
        secondBtnTitle="Add Employee"
        firstBtn
        secondBtn
      />
      <ReferralTable onClick={() => {}} />
    </Box>
  );
};
export default Referrals;
